import * as React from 'react';

const useImageSlider = (totalImages, { elementIdentifierString ='scroller' , initialIndex =0 , enableKeyEvents =false  })=>{
    const [activeIndex, setActiveIndex] = React.useState(initialIndex || 0);
    const interruptSwitchEffect = React.useRef(false);
    const setSlide = React.useCallback((index)=>{
        if (index !== activeIndex) {
            setActiveIndex(index);
        }
    }, [
        activeIndex
    ]);
    const prevSlide = React.useCallback(()=>{
        setActiveIndex((index)=>index !== 0 ? index - 1 : 0
        );
    }, []);
    const nextSlide = React.useCallback(()=>{
        setActiveIndex((index)=>index !== totalImages - 1 ? index + 1 : totalImages - 1
        );
    }, [
        totalImages
    ]);
    React.useEffect(()=>{
        setActiveIndex(initialIndex || 0);
    }, [
        initialIndex
    ]);
    React.useEffect(()=>{
        if (!enableKeyEvents) {
            // Only enable key events when true to prevent conflicts with other keyboard events
            return;
        }
        function handleKeyDownEvent(event) {
            switch(event.key){
                case 'Left':
                case 'ArrowLeft':
                    event.preventDefault();
                    prevSlide();
                    break;
                case 'Right':
                case 'ArrowRight':
                    event.preventDefault();
                    nextSlide();
                    break;
            }
        }
        const target = document;
        if (target) {
            target.addEventListener('keydown', handleKeyDownEvent, false);
            return ()=>target.removeEventListener('keydown', handleKeyDownEvent, false)
            ;
        }
    }, [
        enableKeyEvents,
        nextSlide,
        prevSlide
    ]);
    const handleInView = React.useCallback((inView, index)=>{
        if (inView && index !== activeIndex) {
            setSlide(index);
            interruptSwitchEffect.current = true;
        }
    }, [
        activeIndex,
        setSlide
    ]);
    React.useEffect(()=>{
        if (!interruptSwitchEffect.current) {
            var ref;
            (ref = document === null || document === void 0 ? void 0 : document.getElementById(`${elementIdentifierString}-${activeIndex}`)) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                block: 'nearest'
            });
        } else {
            interruptSwitchEffect.current = false;
        }
    }, [
        activeIndex
    ]);
    const onFirstSlide = activeIndex < 1;
    const onLastSlide = activeIndex >= totalImages - 1;
    return {
        setSlide,
        handleInView,
        prevSlide,
        nextSlide,
        onFirstSlide,
        onLastSlide,
        activeIndex,
        interruptSwitchEffect
    };
};

export { useImageSlider };
//# sourceMappingURL=use-image-slider.js.map
